module.exports = __webpack_public_path__ + "static/media/1-LogiTrack.6a4a795e.jpg";